import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SERVICES } from "@/data/site";

function ServiceCard({ s, i }) {
  const Icon = Icons[s.icon] || Icons.Sparkles;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
      data-testid={`service-card-${s.key}`}
      className="group relative overflow-hidden border border-white/10 bg-[#0A111F] p-8 transition-colors duration-300 hover:bg-[#0d1526]"
    >
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[radial-gradient(circle_at_50%_0%,rgba(0,229,255,0.1),transparent_70%)]" />
      <div className="relative z-10">
        <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-sm border border-white/10 text-cyan-glass transition-colors duration-300 group-hover:border-cyan-glass/50">
          <Icon className="h-6 w-6" strokeWidth={1.4} />
        </div>
        <h3 className="font-heading text-xl font-medium tracking-tight text-white mb-3">
          {s.name}
        </h3>
        <p className="text-sm font-light leading-relaxed text-white/55">{s.desc}</p>
      </div>
    </motion.div>
  );
}

export default function Services() {
  return (
    <section id="leistungen" className="relative bg-[#030712] py-28 md:py-36 grid-lines">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-glass mb-5">
              Unsere Leistungen
            </p>
            <h2 className="font-heading text-4xl md:text-6xl font-medium tracking-tight text-white max-w-2xl">
              Alles rund um Glas & Gebäude
            </h2>
          </div>
          <p className="text-base font-light text-white/50 max-w-sm">
            14 spezialisierte Leistungen — von der einzelnen Scheibe bis zur kompletten Objektbetreuung.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.key} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
